import React, { ReactElement } from 'react';
import { t } from '@sm/intl';
import { Container, Typography } from '@sm/wds-react';
import { createSurveyStyles } from '@sm/webassets';
import COPY from '~app/pages/EnterpriseThankYouV2/copy';
import { HeaderTextPropsType, HeaderTypeEnum } from '../../types';

const useStyles = createSurveyStyles(theme => {
  return {
    headerTextTheming: {
      color: theme?.titleColor,
      fontFamily: theme?.pageTitle?.fontFamily,
    },
  };
});

const Text = ({ text, headerType }: HeaderTextPropsType): ReactElement => {
  const { headerTextTheming } = useStyles();
  const hasText = !!`${text}`.trim();
  const allowCustomText = headerType === HeaderTypeEnum.PREMIUM;
  const resultText = hasText && allowCustomText ? text : t(COPY.THANK_YOU);

  return (
    <Container className="sm-enterprise-thank-you__header-text" flex flexJustify="center">
      <Typography
        data-testid="Text__Header"
        className={`${headerTextTheming} sm-enterprise-thank-you__header-text-inner`}
        component="h1"
        align="center"
        color="dark"
      >
        {resultText}
      </Typography>
    </Container>
  );
};

export default Text;
